import React, { useRef } from "react";

export const useRefState = (initState) => {
    const ref = useRef(initState)
    const state = ref.current;
    const setState = (state) => ref.current = state;
    return [state, setState]
}